import ApiClient from '../helpers/ApiClient';

export const getCqaStaffPriorityData = async () => {
    try {
        const response = await ApiClient.get(`academicPage/cqaStaffCount`);
        return response;
    } catch (error) {
        throw error;
    }
}

export const updateCqaStaffPriority = async ({ id, order }) => {
    try {
        const response = await ApiClient.put(`academicPage/cqaStaffOrder/${id}`,
            { order },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
        return response;
    } catch (error) {
        throw error;
    }
};
